import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HotToastService } from '@ngxpert/hot-toast';
import { AuthService } from '../../../core/auth.service';
import { CommonService } from '../../../services/common.service';
import { SpinnerWhiteComponent } from '../spinner-white/spinner-white.component';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule, RouterOutlet, FormsModule, CommonModule, SpinnerWhiteComponent, RouterLink],
  templateUrl: './login.component.html',
  styles: ``
})
export class LoginComponent {

  /*--- Login form ---*/
  loginForm = this.formBuilder.group({
    emailID: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required, Validators.minLength(3)]]
  })
  spinner: boolean = false
  userID: string | undefined;
  fileResult: any;
  fileName: string = ''
  fileExists: boolean = true;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly toast: HotToastService,
    private readonly route: ActivatedRoute,
    private readonly auth: AuthService,
    private readonly commonService: CommonService
  ) {
    if (sessionStorage.getItem('stopdirection')) {
      const some = JSON.parse(sessionStorage.getItem('stopdirection') || '{}');
      this.router.navigate([some]);
    } else {
      this.router.navigate(['/login']);
    }
    this.route.params.subscribe((params) => {
      this.userID = params['id'];
    });
    this.route.queryParams.subscribe((params) => {
      if (params["email"] != null && params['token'] != null && params['project_id'] != null) {
        this.userID = params['email'];
        localStorage.setItem("Email", params['email'].split("@")[0]);
      }
    });
  }

  /*--- Login form controls ---*/
  get f(): any { return this.loginForm.controls; }

  resetUser() {
    this.loginForm.controls.emailID.reset()
  }

  resetPassword() {
    this.loginForm.controls.password.reset()
  }

  /*--- Login form method ---*/
  onSubmit(formValue: any) {
    this.spinner = true
    if (this.fileResult == undefined) {
      this.fileResult = "null"
    }
    else {
      this.fileResult = this.fileResult.split(",")[1]
    }
    this.auth.loginAction(formValue);
    this.auth.LoginResponse.subscribe((data: any) => data == null ? '' : this.spinner = false)
    this.loginForm.reset()
  }
}
